export default __webpack_public_path__ + "static/media/EmptyHistoryAlert.186f0fed.svg";